import { render, staticRenderFns } from "./BannerEdition.vue?vue&type=template&id=7610935d&scoped=true"
import script from "./BannerEdition.vue?vue&type=script&lang=js"
export * from "./BannerEdition.vue?vue&type=script&lang=js"
import style0 from "./BannerEdition.vue?vue&type=style&index=0&id=7610935d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610935d",
  null
  
)

export default component.exports